/**
 * 대분류 카테고리
 * onDrop 이벤트에서 로직 분기처리를 위해 사용됨
 */
const DnD_element_type_category = {
  MENU : "MENU",
  REN_ELEM : "REN_ELEM"
}

/**
 * 랜더링 된 요소들 (REN_ELEM)에 대한 타입
 */
const DnD_element_type = {
  ELEMENT : {
    MESSAGE : "MESSAGE",
    SLIDE_PAGE : "SLIDE_PAGE"
  },
  COMPONENT : {
    NORMAL : {
      TEXT : {
        inDepth : "TEXT_depth",
        outDepth : "TEXT",
      },
      BUTTON : {
        inDepth : "BUTTON_depth",
        outDepth : "BUTTON",
      },
      IMAGE : {
        inDepth : "IMAGE_depth",
        outDepth : "IMAGE",
      },
      GROUP : "GROUP"
    },
    SPECIAL : {
      ADDR : "ADDR",
      TEL : "TEL",
      DATE : "DATE"
    }
  }
}

/**
 * 메뉴 요소에 대한 타입
 */
const DnD_element_type_menu = {
  ELEMENT : {
    MESSAGE : "_MESSAGE",
    SLIDE_PAGE : "_SLIDE_PAGE"
  },
  COMPONENT : {
    NORMAL : {
      TEXT : "_TEXT",
      BUTTON : "_BUTTON",
      IMAGE : "_IMAGE",
      GROUP : "_GROUP"
    },
    SPECIAL : {
      ADDR : "_ADDR",
      TEL : "_TEL",
      DATE : "_DATE"
    }
  }
}

/**
 * 객체의 모든 프로퍼티 값을 참조하여 배열로 반환합니다.
 * 프로퍼티에 해당하는 값이 String일 때에만 참조한 값을 반환합니다.
 * @param {Object} obj 
 */
const getObjectPropValues = (obj) => {
  const keys = Object.keys(obj)
  const result = []
  
  for (let index=0 ; index < keys.length ; index++) {
    const value = obj[keys[index]]
    if (typeof value === 'string') result.push(value)
  }
  return result
}

/**
 * Response messages data regexp
 */
export const MCSL_SCRIPT_REGEXP = /{%[^=][\s]*?.+?[\s]*?%}/g;
export const MCSL_SCRIPT_WITH_PRINT_REGEXP = /{%[^=]?[\s]*?.+?[\s]*?%}/g;

/**
 * 카테고리의 모든 타입
 */
export const getAllTypes_cat = [
  ...getObjectPropValues(DnD_element_type_category),
]
/**
 * 메뉴의 컴포넌트의 모든 타입
 */
export const getAllTypes_menu = [
  ...getObjectPropValues(DnD_element_type_menu.ELEMENT),
  ...getObjectPropValues(DnD_element_type_menu.COMPONENT.NORMAL),
  ...getObjectPropValues(DnD_element_type_menu.COMPONENT.SPECIAL),
]
/**
 * 랜더링 된 컴포넌트의 모든 타입 (inDepth 제외)
 */
export const getAllTypes_component = [
  ...getObjectPropValues(DnD_element_type.ELEMENT),
  ...getObjectPropValues(DnD_element_type.COMPONENT.NORMAL),
  DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth,
  ...getObjectPropValues(DnD_element_type.COMPONENT.SPECIAL),
]
/**
 * 모든 타입 (inDepth 제외)
 */
export const getAllTypes = [
  ...getObjectPropValues(DnD_element_type_menu.ELEMENT),
  ...getObjectPropValues(DnD_element_type_menu.COMPONENT.NORMAL),
  DnD_element_type.COMPONENT.NORMAL.TEXT.outDepth,
  DnD_element_type.COMPONENT.NORMAL.BUTTON.outDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.outDepth,
  ...getObjectPropValues(DnD_element_type_menu.COMPONENT.SPECIAL),
  ...getObjectPropValues(DnD_element_type.ELEMENT),
  ...getObjectPropValues(DnD_element_type.COMPONENT.NORMAL),
  ...getObjectPropValues(DnD_element_type.COMPONENT.SPECIAL),
]
/**
 * inDepth 컴포넌트의 모든 타입
 */
export const getAllTypes_inDepthType = [
  DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth,
  DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth,
]

export {DnD_element_type_category}
export {DnD_element_type}
export {DnD_element_type_menu}